module.exports = __webpack_public_path__ + "static/img/dc-logo-1.969a2646.png";